import { jsxs, jsx } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import { isOutputState, isCallState } from "./types.js";
import { SECTION_STAGGER_MS, sectionFadeInStyle, toolProductToSectionProduct } from "./utils.js";
import { ProductGroupCarousel } from "../../ProductGroupCarousel.js";
function ProductCarouselsPart({
  part,
  allParts
}) {
  var _a;
  const suppressOutput = allParts.some((p) => p.type === "data-product-carousels" || p.type === "data-section");
  const sections = isOutputState(part.state) ? (_a = part.output) == null ? void 0 : _a.sections : void 0;
  const sectionCount = (sections == null ? void 0 : sections.length) ?? 0;
  const [visibleCount, setVisibleCount] = useState(0);
  useEffect(() => {
    if (!sectionCount) {
      setVisibleCount(0);
      return;
    }
    setVisibleCount(0);
    let count = 0;
    const timer = setInterval(() => {
      count += 1;
      setVisibleCount(count);
      if (count >= sectionCount) clearInterval(timer);
    }, SECTION_STAGGER_MS);
    return () => clearInterval(timer);
  }, [sectionCount]);
  if (isCallState(part.state)) return null;
  if (suppressOutput) return null;
  if (isOutputState(part.state) && sections && sections.length > 0) {
    return /* @__PURE__ */ jsxs("div", { className: "concierge-product-sections", children: [
      /* @__PURE__ */ jsx("style", { dangerouslySetInnerHTML: { __html: sectionFadeInStyle } }),
      sections.map((section, sIdx) => {
        if (sIdx >= visibleCount) return null;
        const sectionSkus = (section.products || []).map((p) => p.stacklineSku).filter(Boolean);
        const products = (section.products || []).map(toolProductToSectionProduct);
        if (products.length === 0) return null;
        return /* @__PURE__ */ jsxs(
          "div",
          {
            className: "concierge-section",
            style: {
              animation: "concierge-fade-in 0.35s ease-out both"
            },
            children: [
              /* @__PURE__ */ jsx("h3", { className: "concierge-section-title", children: section.title }),
              section.description && /* @__PURE__ */ jsx("p", { className: "concierge-section-description", children: section.description }),
              /* @__PURE__ */ jsx(ProductGroupCarousel, { products, allStacklineSkus: sectionSkus })
            ]
          },
          sIdx
        );
      })
    ] });
  }
  return null;
}
export {
  ProductCarouselsPart
};
//# sourceMappingURL=ProductCarouselsPart.js.map
